export default {
  CanViewKsefSettings: 'CanViewKsefSettings',
  CanEditKsefSettings: 'CanEditKsefSettings',
  CanViewKsefPurchaseInvoicesList: 'CanViewKsefPurchaseInvoicesList',
};
